import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import { history } from '../../routers/AppRouter';
import { startSetImpersonateData } from '../../actions/profile';
import AsyncSelect from '../../components/AsyncSelect';
import { getFilteredGroups } from '../../actions/async_select_actions';

import { deserializeData, serializeProfile } from './impersonateSerializer';
import FloatingModal from '../../components/Modal/FloatingModal';

const ImpersonateModal = ({
  profile,
  toggleModal,
  translate,
  startSetImpersonateData,
  getFilteredGroups,
  isModalOpen
}) => {
  const [group, setGroup] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const profileData = deserializeData(_.cloneDeep(profile));
    setGroup(profileData.group || []);
    setAccountId(profileData.accountId || null);
    setMessage('');
  }, [profile]);

  const handleInputChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'group') {
      setGroup(value);
    } else if (name === 'accountId') {
      setAccountId(value);
    }
    setMessage('');
  };

  const handleCancel = () => {
    toggleModal();
  };

  const onSubmit = () => {
    if (_.isEmpty(group)) {
      setMessage(translate('impersonate_group'));
      return;
    }

    const { groupId, accountId: serializedAccountId } = serializeProfile({
      group,
      accountId
    });
    startSetImpersonateData(groupId, serializedAccountId);
    history.push('/group-overview');
  };

  return (
    <FloatingModal
      isOpen={isModalOpen}
      toggleModal={toggleModal}
      header={translate('impersonate')}
      translate={translate}
      onCancel={handleCancel}
      onConfirm={onSubmit}
      confirmLabel={translate('impersonate')}
      size="small"
    >
      <section>
        <Form>
          <Card>
            {message && (
              <CardHeader>
                <p>{message}</p>
              </CardHeader>
            )}
            <CardBody>
              <FormGroup>
                <Label>{translate('groups')}</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-lock" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <AsyncSelect
                    name="group"
                    multiple={false}
                    value={group}
                    placeholder={translate('groups_select')}
                    onSelect={handleInputChange}
                    getData={getFilteredGroups}
                  />
                </InputGroup>
              </FormGroup>
            </CardBody>
          </Card>
        </Form>
      </section>
    </FloatingModal>
  );
};

const mapStateToProps = state => ({
  profile: state.profile.profileData
});

const mapDispatchToProps = dispatch => ({
  startSetImpersonateData: (groupId, accountId, groupData) =>
    dispatch(startSetImpersonateData(groupId, accountId, groupData)),
  getFilteredGroups: (page, perPage, query) =>
    dispatch(getFilteredGroups(page, perPage, query))
});

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonateModal);
